// Componente de layout principal que envolve todas as páginas autenticadas
import * as React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import Sidebar from '../components/Sidebar/Sidebar';
import Navbar from '../components/Navbar/Navbar';
import { useLayout } from '../contexts/LayoutContext';

const useStyles = makeStyles({
  root: {
    backgroundColor: tokens.colorNeutralBackground1,
  },
  backdrop: {
    position: 'fixed',
    top: '56px',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 998,
    display: 'none',
    '@media (max-width: 768px)': {
      display: 'block',
    },
  },
  main: {
    padding: '20px',
    paddingTop: '76px', // 56px da navbar + 20px de padding
    minHeight: 'calc(100vh - 56px)',
    backgroundColor: '#f8f9fa',
  },
});

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const styles = useStyles();
  const { sidebarCollapsed, sidebarOpen, setSidebarOpen } = useLayout();

  const getMarginLeft = () => {
    if (window.innerWidth < 768) {
      return sidebarOpen ? '240px' : '0px';
    }
    return sidebarCollapsed ? '60px' : '240px';
  };

  return (
    <div className={styles.root}>
      <Navbar />
      <Sidebar />
      {sidebarOpen && window.innerWidth < 768 && (
        <div className={styles.backdrop} onClick={() => setSidebarOpen(false)} />
      )}
      <main className={styles.main} style={{ marginLeft: getMarginLeft() }}>
        {children}
      </main>
    </div>
  );
};